import * as React from "react";
//import Box from "@mui/material/Box";
//import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
//import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Stack } from "@mui/system";

const style = {
  //position: "left",
  //top: "50%",
  //right: "70%",
  //transform: "translate(+260%, +0%)",
  width: 500,
  //bgcolor: "background.paper",
  //border: "2px solid #000",
  //boxShadow: 30,
  p: 2,
};

export default function ModalValidation({ openValid, setOpenValid }) {
  const handleEnd = () => setOpenValid(false);
  //value={saveData[0]?.numrklurp || ""}
  return (
    <div>
      <Modal
        open={openValid}
        onClose={handleEnd}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Stack sx={style} spacing={2}>
          <Alert severity="info" />
        </Stack>
      </Modal>
    </div>
  );
}
